import * as React from 'react'
import { FC, useCallback } from 'react'
import { ISalesFunnelSectionEditModel } from '@user/store/salesFunnel/typings'
import { styles } from './hooks/useStyles'
import { SalesFunnelStageList } from './SalesFunnelStageList'
import Button from '@mui/material/Button'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { addEditFunnelStage } from '@user/store/salesFunnel/editSlice'
import Box from '@mui/material/Box'

interface Props {
  section: ISalesFunnelSectionEditModel
}

export const SalesFunnelSection: FC<Props> = (props) => {
  const {
    section: { id, name },
  } = props

  const dispatch = useAppDispatch()

  const addStage = useCallback(() => {
    dispatch(addEditFunnelStage(id))
  }, [dispatch, id])
  return (
    <Box sx={styles.section}>
      <Box sx={styles.sectionHeader}>
        <span style={styles.sectionLabel}>{name}</span>
        <Button
          variant="text"
          color="primary"
          onClick={addStage}
          data-test-id={`${name}-Lnk`}
        >
          + Add New {name}
        </Button>
      </Box>
      <SalesFunnelStageList sectionId={id} sectionName={name} />
    </Box>
  )
}
